import { Locale } from 'next-intl'

import { LOCALE } from '@constants/constants.i18n'
import { toEnum } from '@lib/common-utils'

export type OpenHourType = (typeof OPEN_HOUR_TYPES)[number]
export const OPEN_HOUR_TYPES = ['regular', 'closed', 'special', 'holiday'] as const
export const OPEN_HOUR_TYPE = toEnum(OPEN_HOUR_TYPES)

export type DayOfWeek = (typeof DAY_OF_WEEK_TYPES)[number]
export const DAY_OF_WEEK_TYPES = ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY'] as const
export const DAY_OF_WEEK = toEnum(DAY_OF_WEEK_TYPES)

export type StoreOpenCloseStatus = (typeof STORE_OPEN_CLOSE_STATUSES)[number]
export const STORE_OPEN_CLOSE_STATUSES = ['OPEN_NOW', 'CLOSED_NOW', 'CLOSED_TODAY'] as const
export const STORE_OPEN_CLOSE_STATUS = toEnum(STORE_OPEN_CLOSE_STATUSES)

export type Province = (typeof PROVINCES)[number]
export const PROVINCES = ['AB', 'BC', 'MB', 'NB', 'NL', 'NS', 'ON', 'PE', 'QC', 'SK'] as const
export const PROVINCE = toEnum(PROVINCES)

export const LUXON_STORE_TIME_HOUR_FORMAT_MAP = {
  [LOCALE.en]: 'h:mm a',
  [LOCALE.fr]: `HH:mm'h'`
} as const satisfies { [L in Locale]: string }

export const DAY_OF_WEEK_TO_DAY_CODE = {
  SUNDAY: '0',
  MONDAY: '1',
  TUESDAY: '2',
  WEDNESDAY: '3',
  THURSDAY: '4',
  FRIDAY: '5',
  SATURDAY: '6'
} as const satisfies { [k in DayOfWeek]: string }
